/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Web_1Inputs */

const en_pc_dl_web_1 = /** @type {(inputs: Pc_Dl_Web_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just want to use it? Open our hosted copy. There is nothing to install.`)
};

const zh_pc_dl_web_1 = /** @type {(inputs: Pc_Dl_Web_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只想直接用？打开我们托管的在线版，无需安装。`)
};

/**
* | output |
* | --- |
* | "Just want to use it? Open our hosted copy. There is nothing to install." |
*
* @param {Pc_Dl_Web_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_web_1 = /** @type {((inputs?: Pc_Dl_Web_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Web_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_web_1(inputs)
	return zh_pc_dl_web_1(inputs)
});
export { pc_dl_web_1 as "pc.dl.web.1" }